import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { BaseNewRequestControlName } from '../../../../shared/base-new-request-form/base-new-request-form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  DPNewRequestControlName,
  DPNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class DPNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<DPNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonApplicantFormGroup({
        [BaseNewRequestControlName.ContactData]: true,
      }).controls,
      [DPNewRequestControlName.DemolitionInformation]: [
        getDefaultControlValue(),
        Validators.required,
      ],
    });
  }
}
